/* eslint-disable */


/**
 * Create styles for `<BannerNotification />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<BannerNotification />` styles
 */
const BannerNotificationStyles = ({ theme }) => ({});

export default BannerNotificationStyles;
